<template>
    <div style="background: #ededed;">
        <section class="container list-wrap">
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="control-label"><span class="text-danger">*标题</span></label>
                    <div>
                        <input v-model="title" class="form-control" type="text">
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label"><span class="text-danger">*内容</span></label>
                    <div>
                        <textarea v-model="content" class="form-control" maxlength="2000" rows="5"
                            style="height: auto;resize: vertical;"></textarea>
                        <p>您还可以输入<span style="color:#1d74d5; font-size:18px;">{{2000 - content.length}}</span>字</p>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label"><span class="text-danger">联系方式</span></label>
                    <div>
                        <input v-model="contact" class="form-control" type="text">
                    </div>
                </div>
                <div class="">
                    <button type="button" class="btn" @click="submit()">提交</button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                title: '',
                content: '',
                contact: ''
            }
        },
        methods: {
            submit() {
                if (this.title === '') {
                    this.$message.error('请输入标题');
                    return false;
                }
                if (this.content === '') {
                    this.$message.error('请输入内容');
                    return false;
                }
                const data = {
                    title: this.title,
                    content: this.content,
                    contact: this.contact
                }
                axios.post('http://www.yijian.sh.cn/dist/wordpress/suggest.php',data)
                    .then(response => {
                        console.log(response);
                        if(response.data.status === 200) {
                            this.$message.success('提交成功');
                            this.title = '';
                            this.content = '';
                            this.contact = '';
                        }else {
                            this.$message.error('提交失败');
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    })
            }
        }
    }
</script>

<style scoped>
    .list-wrap {
        min-height: calc(100vh - 575.5px);
        height: auto;
        background: #fff;
        overflow: hidden;
    }

    .form-horizontal {
        width: 64.25rem;
        margin: 2.625rem auto;
    }

    .text-danger {
        color: #a94442;
    }

    .control-label {
        font-size: 1rem;
        font-weight: bold;
        padding-top: 0.5rem;
        margin-bottom: 0;
        text-align: right;
        width: 10.214285rem;
        margin-right: 1rem;
    }

    .form-group {
        display: flex;
        align-items: flex-start;
        margin-bottom: 1.071428rem;
    }

    .form-control {
        display: block;
        width: 40.714285rem;
        height: 2.428571rem;
        padding: 0.428571rem 0.857142rem;
        font-size: 1rem;
        line-height: 1.42857143rem;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 0.071428rem solid #ccc;
        border-radius: 0.285714rem;
        box-shadow: inset 0 0.071428rem 0.071428rem rgba(0, 0, 0, .075);
        transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    }

    .btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15.785714rem;
        height: 3.285714rem;
        color: #fff;
        font-weight: bold;
        background-color: #f0ad4e;
        border-radius: 0.428571rem;
        border: none;
        margin: 0 auto;
    }
</style>
